// Slices for Initial State, Actions/Functions
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import fileService from "./fileService";

// Create Initial State for File
const initialState = {
  fileData: {},
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const extractInvoiceData = createAsyncThunk(
  "file/upload/invoice",
  async (invoice, thunkAPI) => {
    try {
      return await fileService.extractInvoiceData(invoice);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Slice is collection of Reducers for Redux
export const fileSlice = createSlice({
  name: "file",
  initialState,
  reducers: {
    // Ability to dispatch Reset function after Register or Login
    reset: (state) => {
      state.fileData = {};
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(extractInvoiceData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(extractInvoiceData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.fileData = action.payload;
      })
      .addCase(extractInvoiceData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = fileSlice.actions;
export default fileSlice.reducer;
